// src/stone/icons/StoneAgentShakingHands.tsx
import { jsx } from "react/jsx-runtime";
var StoneAgentShakingHands = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M4.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M19.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M16 4.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M1.172 10.172A4 4 0 0 1 4 9c1.863 0 3.059 1.028 3.96 1.932.169.17.32.327.464.476.268.278.508.527.778.769.39.35.745.587 1.12.714a1 1 0 1 1-.643 1.894c-.732-.248-1.32-.678-1.811-1.118-.324-.29-.654-.632-.952-.94a33 33 0 0 0-.373-.383C5.718 11.516 5.02 11 4 11a2 2 0 0 0-2 2v8h4v-5a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-9a4 4 0 0 1 1.172-2.828M16.133 13.667c-.492.44-1.08.87-1.812 1.118a1 1 0 1 1-.642-1.894c.374-.127.729-.364 1.12-.714.27-.242.51-.491.777-.769.143-.15.295-.307.464-.476C16.941 10.028 18.137 9 20 9a4 4 0 0 1 4 4v9a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-6a1 1 0 1 1 2 0v5h4v-8a2 2 0 0 0-2-2c-1.02 0-1.718.516-2.543 1.344-.117.116-.242.246-.373.382-.298.31-.628.65-.951.94" })
  }
);
var StoneAgentShakingHands_default = StoneAgentShakingHands;

export {
  StoneAgentShakingHands,
  StoneAgentShakingHands_default
};
